<template>
  <div class="toast">
    <el-dialog :visible="isshow" :modal-append-to-body="false" @close="changeStatus">
      <div slot="title" class="jumFpeedback_head">
        <img src="/img/logo.e85e07f3.png" alt="" />
        <b></b>
        <span v-if="authData">绑定账户</span>
        <span v-else>注册</span>
      </div>
      <div class="jumpFeedback_body">
        <div class="user">
          <input
            type="text"
            v-model="phone"
            placeholder="在此输入手机号/邮箱"
            @focus="focusFn"
            @input="changeFn"
            @blur="blurFn"
          />
          <img v-show="status.delIsShow" src="/img/del.3e24f5a3.png" alt="" @click="delBtn" />
        </div>
        <div class="code">
          <el-input v-model="code" placeholder="请输入验证码" />
          <el-button type="primary" @click="btnTimeFn">
            {{ isClickBtn ? `重新发送${time}s` : '获取验证码' }}
          </el-button>
        </div>
        <div class="inputSty">
          <el-input v-model="name" placeholder="请设置昵称" />
        </div>
        <div class="inputSty">
          <el-input type="password" v-model="password" placeholder="请设置密码" />
        </div>
        <div class="agreement">
          <el-checkbox v-model="agreementStatus" />
          &nbsp;同意
          <span style="cursor: pointer; color: #409EFF" @click="agreementShowFn(1)">《用户协议》</span>
          &nbsp;
          <span style="cursor: pointer; color: #409EFF" @click="agreementShowFn(2)">《隐私政策》</span>
        </div>
        <div :class="agreementStatus ? 'loginBtn active' : 'loginBtn'" @click="registerFn">
          <span v-if="authData">绑定账户</span>
          <span v-else>注册</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span></span>
        <div class="elseLogin">
          <span @click="goLogin">立即登录</span>
        </div>
      </div>
    </el-dialog>
    <Agreement :state="agreementShow" :content-id="agreementId" @closeState="closeAgreement" />
  </div>
</template>

<script>
import axios from 'axios'
import { setToken, setUser } from '@/utils/auth'
import Agreement from './Agreement.vue'

function validatePassword(vm, pwd) {
  const reg = /^((\d+[A-Za-z]+)|([A-Za-z]+\d+))$/
  if (reg.test(pwd)) return true
  vm.$message({ showClose: true, message: '请输入正确格式的密码，必须由数字和字母组成!', type: 'warning', duration: 1000 })
  return false
}

export default {
  name: 'RegisteredToast',
  components: { Agreement },
  data() {
    return {
      phone: '',
      code: '',
      name: '',
      password: '',
      agreementStatus: false,
      isClickBtn: false,
      time: 59,
      status: { styleStatus: false, delIsShow: false },
      isGoLogin: false,
      agreementShow: false,
      agreementId: 1,
      isshow: false
    }
  },
  props: {
    state: { type: Boolean, default: false },
    isClose: { type: Function, default() {} }
  },
  computed: {
    authData() {
      return this.$store.state.data
    }
  },
  watch: {
    state() { this.isshow = this.state },
    authData() {
      if (this.$store.state.data) {
        this.isshow = true
        this.name = this.$store.state.nickname
      }
    }
  },
  methods: {
    changeStatus() {
      this.phone = ''
      this.code = ''
      this.password = ''
      this.name = ''
      this.agreementStatus = false
      if (this.isGoLogin) {
        this.isGoLogin = false
        this.isClose(true)
        return
      }
      this.isClose(false)
    },
    closeAgreement() { this.agreementShow = false },
    agreementShowFn(id) { this.agreementShow = true; this.agreementId = id },
    goLogin() { this.isGoLogin = true; this.isshow = false },
    focusFn() { this.status.styleStatus = true },
    blurFn() {
      this.status.styleStatus = false
      this.status.delIsShow = false
      if (this.phone) this.status.delIsShow = true
    },
    changeFn() { this.status.delIsShow = !!this.phone },
    delBtn() { this.phone = ''; this.status.delIsShow = false },
    btnTimeFn() {
      if (this.isClickBtn) return
      this.isClickBtn = true
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      const emailReg = /^[A-Za-z0-9_一-龥]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.phone && (phoneReg.test(this.phone) || emailReg.test(this.phone))) {
        const timer = setInterval(() => {
          this.time--
          if (this.time === 0) { clearInterval(timer); this.time = 59; this.isClickBtn = false }
        }, 1000)
        axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.phone } })
      } else {
        this.isClickBtn = false
        this.$message({ showClose: true, message: '请先输入手机号或邮箱', type: 'warning', duration: 1000 })
      }
    },
    registerFn() {
      if (!validatePassword(this, this.password)) return
      if (this.phone && this.code && this.agreementStatus) {
        const data = {
          code: this.code,
          phoneNumOrEmail: this.phone,
          password: this.password,
          name: this.name
        }
        if (this.$store.state.data) data.data = this.$store.state.data
        axios({ method: 'post', url: '/realNet/customer/register', data }).then(res => {
          if (res.data.code == 200) {
            this.loginFn(this.phone, this.password)
            this.$store.state.nickname = null
            this.$store.state.data = null
            this.$message({
              showClose: true, message: '恭喜你注册成功!', type: 'success', duration: 1000,
              onClose: () => { this.$emit('resign', { phone: this.phone, pwd: this.password }) }
            })
          } else {
            this.$message({ showClose: true, message: res.data.message, type: 'warning', duration: 1000 })
          }
        })
      } else if (!this.phone) {
        this.$message({ showClose: true, message: '请先输入手机号或邮箱', type: 'warning', duration: 1000 })
      } else if (!this.code) {
        this.$message({ showClose: true, message: '请先输入验证码', type: 'warning', duration: 1000 })
      } else {
        this.$message({ showClose: true, message: '请勾选用户协议', type: 'warning', duration: 1000 })
      }
    },
    loginFn(phone, pwd) {
      axios({
        method: 'post',
        url: '/realNet/customer/login',
        headers: { token: '123456' },
        data: { loginName: phone, password: pwd }
      }).then(res => {
        if (res.data.code == 200) {
          setToken(res.data.result.token)
          setUser(JSON.stringify(res.data.result.user))
          this.$store.state.name = res.data.result.user.name
          this.isshow = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  ::v-deep .el-dialog {
    width: 480px;
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__footer {
    padding: 0;
  }

  .jumFpeedback_head {
    display: flex;
    align-items: center;

    img { margin-top: 0; }

    b {
      width: 4px;
      height: 4px;
      margin: 0 10px;
      background-color: #3bc0d0;
      border-radius: 50%;
      display: inline-block;
    }

    span {
      font-size: 18px;
      color: #3bc0d0;
    }
  }

  .jumpFeedback_body {
    width: 100%;
    padding: 20px 30px 10px;
    box-sizing: border-box;
    display: block;
    word-break: break-all;
    word-wrap: break-word;

    .user {
      width: 100%;
      height: 55px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e1e9eb;
      display: flex;
      align-items: center;

      input {
        width: 90%;
        height: 30px;
        border: none;
        outline: none;
        font-size: 16px;

        &::placeholder { color: #ccc; }
      }

      img { cursor: pointer; }
    }

    .code {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .inputSty {
      width: 100%;
      margin: 10px 0;
    }

    .agreement {
      margin: 20px 0;
    }

    .loginBtn {
      width: 360px;
      height: 50px;
      margin-top: 20px;
      background-color: #dde1e2;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        color: #fff;
        letter-spacing: 1px;
      }

      &.active {
        background-color: #409eff;
      }
    }
  }

  .dialog-footer {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    background-color: #f3f7f8;
    border-radius: 0 0 8px 8px;

    > span {
      font-size: 14px;
      color: #666;
    }

    .elseLogin {
      width: 45%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;

      span {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>
